import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as AppPropTypes from '../../lib/PropTypes';
import Button from '../buttons/Button';
import Pin from '../icons/Pin';

import styles from '../../../styles/partials/contact-cta.module.scss';

const propTypes = {
    cta: AppPropTypes.cta.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ContactCta = ({ cta, className }) => {
    const { type = 'page', label = null, url = null } = cta || {};

    return (
        <Button
            className={classNames([
                styles.container,
                styles.button,
                {
                    [className]: className !== null,
                },
            ])}
            external={type !== 'page'}
            href={url}
        >
            {type === 'map' ? <Pin className={styles.pin} /> : null}
            <span>{label}</span>
        </Button>
    );
};

ContactCta.propTypes = propTypes;
ContactCta.defaultProps = defaultProps;

export default ContactCta;
